import { InventoryTransferStateEnums, InventoryTransferTypeEnums } from "src/app/enum/inventory-transfer-enums";

export class InventoryTransferModel {
  inventoryTransferId: number = 0;
  inventoryId: number = 0;
  consecutive: number = 0;
  type: number = InventoryTransferTypeEnums.shop;
  state: number = InventoryTransferStateEnums.open;
  dateOutput: Date = new Date;
  dateEntry: Date = new Date;
  inventoryPeriodId: number = 0;
  branchOutputId: number = 0;
  storeOutputId: number = 0;
  branchEntryId: number = 0;
  storeEntryId: number = 0;
  transporterId: number = 0;
  vehicleId: number = 0;
  transportValue: number = 0;
  observation: string | null = null;
  sendDateAccounting: string | null = null;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}
